<!-- Zweck: Stellt die HTML-Struktur für app lieferkunde selector component im Frontend bereit. -->
@if (!differential_mode && user && user.vertreter && (show|async) && !(autoSelecting|async)) {
  <section-title [buttons_right]="section_title_buttons" icon="lieferadresse"
  label="Kunde auswählen"></section-title>
}

@if (!differential_mode && user && user.kunde && (show|async) && !(autoSelecting|async)) {
  <section-title [buttons_right]="section_title_buttons" icon="lieferadresse"
  label="Lieferanschrift auswählen"></section-title>
}

@if (differential_mode && (show|async) && !(autoSelecting|async)) {
  <section-title [buttons_right]="section_title_buttons" icon="lieferadresse" [hasBack]="true"
  label="Lieferung für"></section-title>
}


@if (lieferkundenGroups_filtered && !(show|async) && (autoSelecting|async)) {
  <div class="lieferkundenbox_holder tut_lieferkunden_selector" style="text-align: center; margin-top: 100px">
    <div style="display: inline-block; text-align: center">
      <div style="display: inline-block">
        <h3>Angemeldet als</h3>
        <h1 style="text-shadow: 0 0 1px white">
          @if (domaincfg.show_customer_numbers) {
            <span>
              {{(autoSelecting|async).LieferkundeNr}}
              <br>
              </span>
            }
            {{(autoSelecting|async).Vorname}}
            @if ((autoSelecting|async).Nachname) {
              <div style="font-size: 18px">{{(autoSelecting|async).Nachname}}</div>
            }
            <br>
              <small>{{(autoSelecting|async).Strasse}}, {{(autoSelecting|async).Plz}} {{(autoSelecting|async).Ort}}</small>
            </h1>
          </div>
          <br>
            <br>
              <div style="display: inline-block">
                <mat-spinner></mat-spinner>
              </div>
            </div>
          </div>
        }

        @if ((show|async) && !(autoSelecting|async)) {
          <div class="lieferkundenbox_holder tut_lieferkunden_selector">
            <search-box [(value)]="search" (search)="filter(true)" (valueChange)="search_dirty = true"></search-box>
            @if (user.kunde && !differential_mode) {
              <div style="padding: 5px">
                <mat-checkbox [(ngModel)]="remember_lknd_nr">Künftig automatisch wählen</mat-checkbox>
              </div>
            }
            <div class="lieferkundenbox_holder_inner">
              @if (lieferkundenGroups_filtered) {
                <div>
                  @for (grp of lieferkundenGroups_filtered; track grp) {
                    <div class="lieferkundengroupbox" [class.hasMultiGroups]="lieferkundenGroups_filtered.length > 1" [class.hasMultiChildren]="grp.a3KundeNr != 0 && grp.lieferkunden.length > 1">
                      @if (grp.a3KundeNr != 0 && grp.lieferkunden.length > 1) {
                        <h3>{{grp.label}}</h3>
                      }
                      @for (lk of grp.lieferkunden; track lk) {
                        <div (click)="doSelect(lk)"
                          [class.active]="current_lieferkunde && lk.LieferkundeNr == current_lieferkunde.LieferkundeNr"
                          class="lieferkundenbox mat-elevation-z1"
                          [class.highlight]="(usvc.user$|async)?.kunde && lk.LieferkundeNr == (usvc.user$|async)?.kunde.KundeNr"
                          matTooltip="{{ ((usvc.user$|async)?.kunde && lk.LieferkundeNr == (usvc.user$|async)?.kunde.KundeNr) ? 'Standard Lieferkunde - ' : '' }} Klicken um auszuwählen"
                          >
                          <table>
                            <tr>
                              <td class="icontd" rowspan="2">
                                <svg-icon>lieferadresse</svg-icon>
                              </td>
                              <td class="title">{{lk.Vorname}}</td>
                            </tr>
                            <tr>
                              <td>
                                @if (domaincfg.show_customer_numbers) {
                                  <span>
                                    @if (domaincfg.showA2KndNrOverwrite == 'A2KndNrDefault') {
                                      {{lk.A2KndNrDefault}}
                                    }
                                    @if (domaincfg.showA2KndNrOverwrite == 'A2KndNrOrganisationseinheit') {
                                      {{lk.A2KndNr}}
                                    }
                                    @if (domaincfg.showA2KndNrOverwrite == 'Nein') {
                                      {{lk.LieferkundeNr}}
                                    }
                                    <br>
                                    </span>
                                  }
                                  @if (lk.Nachname) {
                                    <span>
                                      {{lk.Nachname}}
                                    </span>
                                  }
                                  <br>
                                    <small>{{lk.Strasse|trim}}, {{lk.Plz}} {{lk.Ort}}</small>
                                  </td>
                                </tr>
                              </table>
                            </div>
                          }
                        </div>
                      }
                    </div>
                  }
                  @if (lieferkundenGroups_filtered && lieferkundenGroups_filtered.length == 0) {
                    <div style="text-align: center">
                      <h1>
                        @if ((user.vertreter && (!search || search_dirty))) {
                          <info-box type="app-lieferkunde-selector-no-lieferkunden-filtered-vertreter"></info-box>
                        }
                        @if (!(user.vertreter && (!search || search_dirty))) {
                          <info-box type="app-lieferkunde-selector-no-lieferkunden-filtered"></info-box>
                        }
                      </h1>
                    </div>
                  }
                  @if (!lieferkundenGroups_filtered && user.vertreter && !search) {
                    <div>
                      <h1>
                        <info-box type="app-lieferkunde-selector-no-lieferkunden-filtered-vertreter"></info-box>
                      </h1>
                    </div>
                  }
                </div>
              </div>
            }
